export default __webpack_public_path__ + "static/media/Upload_Button_Off.e2890782.svg";